export const get_user_traffic_usage = async (simulation_id = null) => {
  try {
    const req_query = simulation_id ? `?simulation_id=${simulation_id}` : '';
    let response = await fetch(`/rest/traffic/usage${req_query}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
      .then((r) => r.json())
      .catch((err_fetch) => {
        return err_fetch;
      });
    return response;
  } catch (err) {
    return { error: true, errors: err };
  }
};

export const dec_traffic_allowed = async () => {
  try {
    let response = await fetch(`/rest/traffic/usage/dec_traffic`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
      .then((r) => r.json())
      .catch((err_fetch) => {
        return err_fetch;
      });
    return response;
  } catch (err) {
    return { error: true, errors: err };
  }
};

export const get_extension_packs = async () => {
  try {
    let response = await fetch(`/rest/stripe/extension-packs`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
      .then((r) => r.json())
      .catch((err_fetch) => {
        return err_fetch;
      });
    return response;
  } catch (err) {
    return { error: true, errors: err };
  }
};
